import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import AddBlogLayer from "../../components/AddBlogLayer";
import MasterLayout from "../../masterLayout/MasterLayout";
import AddBlog from "../../components/AddBlog/AddBlog";
import AddCaseStudy from "../../components/AddCaseStudy/AddCaseStudy";
const CreateCaseStudyPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Add New Case Study' />

                <AddCaseStudy />
            </MasterLayout>
        </>
    );
};

export default CreateCaseStudyPage;
